export default __webpack_public_path__ + "locales/zh-CN/InviteDialog.json?hash=6a36be5e601312bbac50fed06947f3cb";